export const numberOfCountries = 11;
export const numberOfProjects = 300;
export const personnelDepPlEmail = 'personneldepartment.poland@ventionteams.com';

export const QUESTIONNAIRES = {
  RU: {
    id: 1,
  },
  ENG: {
    id: 2,
  },
  PL: {
    id: 3,
  },
  ENG_WITHOUT_CONTACTS: {
    id: 4,
  },
};

export const FEEDBACK_FORM_SUBJECT = 'Mail Generator: Feedback or report an issue';
